/** 
	 * Remove diferença de horário entre uma data UTC e local
	 * (UTC -3:00 BR)
* */
const removeDifferenceBetweenUTCAndLocal = (date: Date) => {
	const newTimeAndDate = new Date(date);
	const hoursDiff = newTimeAndDate.getHours() - newTimeAndDate.getTimezoneOffset() / 60;
	const minutesDiff = newTimeAndDate.getMinutes() - (newTimeAndDate.getTimezoneOffset() % 60);
	newTimeAndDate.setHours(hoursDiff);
	newTimeAndDate.setMinutes(minutesDiff);
	return newTimeAndDate;
};

export default removeDifferenceBetweenUTCAndLocal;
